import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NgCakeItEasyUtilsModule } from '@cakeiteasy/web-utils';
import { CakeItEasyWebUiModule } from '@cakeiteasy/web-ui';

import { UnifiedOrderInfoTableComponent } from './unified-order-info-table.component';
import { ProductTbodyComponent } from './components/product-tbody/product-tbody.component';
import { ExtraProductTbodyComponent } from './components/extra-product-tbody/extra-product-tbody.component';
import { GroupedExtraProductTbodyComponent } from './components/grouped-extra-product-tbody/grouped-extra-product-tbody.component';
import { OrderInfoDeliveryComponent } from './components/order-info-delivery/order-info-delivery.component';
import { OrderInfoPickupComponent } from './components/order-info-pickup/order-info-pickup.component';
import { PaymentIntentSummaryComponent } from './components/payment-intent-summary/payment-intent-summary.component';
import { OrderDiscountTbodyComponent } from './components/order-discount-tbody/order-discount-tbody.component';
import { OrderInfoSummaryComponent } from './components/order-info-summary/order-info-summary.component';
import { SimplifyOrderInfoTableComponent } from './simplify-order-info-table/simplify-order-info-table.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    NgCakeItEasyUtilsModule,
    CakeItEasyWebUiModule,
  ],
  exports: [
    UnifiedOrderInfoTableComponent,
    OrderInfoSummaryComponent,
    SimplifyOrderInfoTableComponent,
  ],
  declarations: [
    UnifiedOrderInfoTableComponent,
    SimplifyOrderInfoTableComponent,
    OrderInfoSummaryComponent,

    ProductTbodyComponent,
    GroupedExtraProductTbodyComponent,
    ExtraProductTbodyComponent,
    OrderInfoDeliveryComponent,
    OrderInfoPickupComponent,
    PaymentIntentSummaryComponent,
    OrderDiscountTbodyComponent,
  ],
})
export class UnifiedOrderInfoTableModule {
}
